document.addEventListener('DOMContentLoaded', function() {

    function daojishi(scopeContainer, endtime) {

        const countdownWrap = scopeContainer.querySelector('.js_djclose');
        const dayEl = scopeContainer.querySelector('.day_show');
        const hourEl = scopeContainer.querySelector('.hour_show');
        const minuteEl = scopeContainer.querySelector('.minute_show');
        const secondEl = scopeContainer.querySelector('.second_show');


        if (!countdownWrap || !dayEl || !hourEl || !minuteEl || !secondEl) {
            return;
        }

        const endTimeStamp = new Date(endtime).getTime();
        if (isNaN(endTimeStamp)) {
            countdownWrap.style.display = 'none';
            return;
        }

        let remainingSeconds = Math.floor((endTimeStamp - Date.now()) / 1000);
        if (remainingSeconds <= 0) {
            countdownWrap.style.display = 'none';
            return;
        }

        let lastDay = -1, lastHour = -1, lastMinute = -1, lastSecond = -1;

        function updateCountdown() {
            remainingSeconds = Math.floor((endTimeStamp - Date.now()) / 1000);
            if (remainingSeconds > 0) {
                const day = Math.floor(remainingSeconds / 86400);
                const hour = Math.floor((remainingSeconds % 86400) / 3600);
                const minute = Math.floor((remainingSeconds % 3600) / 60);
                const second = remainingSeconds % 60;

                const formatNum = num => num.toString().padStart(2, '0');
                const formattedMinute = formatNum(minute);
                const formattedSecond = formatNum(second);


                if (day !== lastDay) {
                    dayEl.textContent = day;
                    lastDay = day;
                }
                if (hour !== lastHour) {
                    hourEl.textContent = hour;
                    lastHour = hour;
                }
                if (minute !== lastMinute) {
                    minuteEl.textContent = formattedMinute;
                    lastMinute = minute;
                }
                if (second !== lastSecond) {
                    secondEl.textContent = formattedSecond;
                    lastSecond = second;
                }


                requestAnimationFrame(() => {
                    setTimeout(updateCountdown, 1000 - (Date.now() % 1000));
                });
            } else {
                countdownWrap.style.display = 'none';
                return;
            }
        }

        updateCountdown();
    }


    function initCountdown() {
        const endTime = "2026-07-29T00:00:00Z"; 

        const isProductDetailPage = window.location.pathname.includes('/products/');
        const isCollectionPage = window.location.pathname.includes('/collections/');
        const ishome = window.location.pathname === '/';

        if (isProductDetailPage) {

            const productDetailContainer = document.querySelector('.product-single, .product-detail');

            const scope = productDetailContainer || document.body;
            daojishi(scope, endTime);
        }


        else if (isCollectionPage) {

            const productItems = document.querySelectorAll('.grid__item, .product-card');

            productItems.forEach(item => {
                daojishi(item, endTime);
            });
        }

        else if (ishome) {

            const productItems = document.querySelectorAll('.grid__item, .product-card, .home-product-item');

            productItems.forEach(item => {
                daojishi(item, endTime);
            });
        }


        else {
            return;
        }
    }


    initCountdown();
});